<template>
    <div>
        <ul class="nav nav-tabs pricingtabs" id="myTab" role="tablist">
            <li
                v-for="(productPrice, index) in pricingOptions"
                class="nav-item"
            >
                <a
                    class="nav-link"
                    v-bind:class="{ 'active': activePriceId === productPrice.id }"
                    :id="getNormalizedCssName(productPrice) + '-tab'"
                    data-toggle="tab"
                    role="tab"
                    :href="'#' + getNormalizedCssName(productPrice)"
                    :aria-controls=getNormalizedCssName(productPrice)
                    v-bind:aria-selected="activePriceId === productPrice.id"
                    @click.prevent="changePrice(index)"
                >{{ productPrice.label }}</a>
            </li>
        </ul>
       
        <div
            class="tab-content"
            id="price-tab-content"
        >


            <div
                v-for="productPrice in pricingOptions"
                class="tab-pane fade"
                v-bind:class="{ 'show active': activePriceId === productPrice.id }"
                role="tabpanel"
                :id=getNormalizedCssName(productPrice)
                :aria-labelledby="getNormalizedCssName(productPrice) + '-tab'"
            >

                <p v-html="displayPrice(productPrice)"></p>
                <i>plus tax</i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProductPricingTab",
    props: ['activePriceId', 'pricingOptions'],
    model: {
        prop: 'price',
        event: 'priceChanged',
    },

    methods: {
        changePrice(index) {
            let newPrice = this.pricingOptions[index];
            this.$emit('priceChanged', newPrice);
        },

        displayPrice(price) {
            if (price.has_sale) {
                return `<span class="oldprice pricing">$${price.amount}</span> ${price.sale_formatted_tab_widget}`;
            }

            return price.formatted_tab_widget;
        },

        getNormalizedCssName(price) {
            return price.label.toLowerCase().split(" ").join("-");
        }
    },
}
</script>

<style scoped>

</style>
